// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2d5OV","footer":"ModalUpdate_footer__19E8M"};